// scss
import {useState, useContext} from "react";
import "./index.scss";
import {StoreContext} from "../../pages/StoreContext";

import FeedbackSucceed from "./FeedbackSucceed";
import FeedbackForm from "./FeedbackForm";

const Feedback = () => {
    // 彈窗
    const [overlay, setOverlay] = useState(false);
    // 表單成功
    const [sendSucceed, setSendSucceed] = useState(true); //true在表單頁，false在成功頁

    
    // templateLink 是由 useParams 抓的值，送進來，才知道正確頁面的錨點
    const {useGtmSender} = useContext(StoreContext);
    // gtm
    const gtmSender = useGtmSender();
    const handleGtmClick = (obj) => {
        gtmSender(obj);
    };

    return (
        <div className="feedback-wrap">
            <div
                className="feedback-tag"
                onClick={() => {
                    // 打開彈窗
                    setOverlay(true);
                    handleGtmClick({
                        event: "問題回饋",
                    });
                }}>
                <p>问题回馈</p>
            </div>
            {overlay && (
                <>
                    {sendSucceed ? (
                        // 表單頁
                        <FeedbackForm setOverlay={setOverlay} setSendSucceed={setSendSucceed} handleGtmClick={handleGtmClick} />
                    ) : (
                        // 成功頁
                        <FeedbackSucceed setOverlay={setOverlay} setSendSucceed={setSendSucceed} />
                    )}

                    <div
                        className="overlay"
                        onClick={() => {
                            setOverlay(false); // 關閉彈窗
                            setSendSucceed(true); //確保是在表單頁
                            handleGtmClick({
                                event: "問題回饋_關閉",
                            });
                        }}></div>
                </>
            )}
        </div>
    );
};
export default Feedback;
